import { ReactElement } from 'react';
import { colorByHealthVariant, parseHealthVariantLabel } from '../../helpers';
import { HealthVariant } from '../UnitsInfo/types';
import { PercentageTooltip } from 'pages/NewOverview/components/History/PercentageTooltip';

interface HealthTooltipGraphProps {
  date: string;
  percentage: number;
  units: number;
  variant: HealthVariant;
}

export function HealthTooltipGraph({
  date,
  units,
  percentage,
  variant,
}: Readonly<HealthTooltipGraphProps>): ReactElement {
  const color = colorByHealthVariant(variant);

  return (
    <PercentageTooltip
      color={color}
      date={date}
      description={parseHealthVariantLabel(variant)}
      percentage={percentage}
      type="month"
      units={units}
    />
  );
}
